import(/* webpackMode: "eager", webpackExports: ["ResetTokenForm"] */ "/app/apps/sb-shell/app/(recaptcha)/password/request-reset/ResetTokenForm.tsx");
